import { render, staticRenderFns } from "./UserReviews.vue?vue&type=template&id=c7a7808c&scoped=true&"
import script from "./UserReviews.vue?vue&type=script&lang=js&"
export * from "./UserReviews.vue?vue&type=script&lang=js&"
import style0 from "./UserReviews.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserReviews.vue?vue&type=style&index=1&id=c7a7808c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a7808c",
  null
  
)

export default component.exports